import script from "./LoginPasswordReset.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginPasswordReset.vue?vue&type=script&setup=true&lang=ts"

import "./LoginPasswordReset.vue?vue&type=style&index=0&id=10128e98&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10128e98"]])

export default __exports__